import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import Locales from 'locales';
import { PreferencesContext } from 'context';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';
import { Spinner } from 'components/ui/spinner';
import PreferencesForm from './PreferencesForm';

const AddCampaignModal = ({ isOpened = false, closeModal = () => {}, onSubmit, currentYear, campaigns, isLoading }) => {
  const {
    registrationDeposit,
    religiousSupervisorsQuota,
    medicalSupervisorsQuota,
    minPilgrimForAuthorization,
    pilgrimEligibilityMinAge,
    totalPilgrimQuota,
    religiousSupervisorsRatio,
    medicalSupervisorsRatio,
  } = useContext(PreferencesContext);

  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      campaign_year: '',
      campaign_registration_end_date: null,
      pilgrim_eligibility_min_age: pilgrimEligibilityMinAge,
      registration_deposit: registrationDeposit,
      certificate_min_active_pilgrim: minPilgrimForAuthorization,
      religious_supervisors_quota: religiousSupervisorsQuota,
      medical_supervisors_quota: medicalSupervisorsQuota,
      religious_supervisors_ratio: religiousSupervisorsRatio,
      medical_supervisors_ratio: medicalSupervisorsRatio,
      total_pilgrim_quota: totalPilgrimQuota,
    },
  });

  const { isValid } = form.formState;
  const campaignYearValue = form.watch('campaign_year');
  const endDateValue = form.watch('campaign_registration_end_date');

  const isSubmitDisabled = isLoading || !isValid || !campaignYearValue || !endDateValue;

  const handleAddCampaign = () => {
    form.handleSubmit(onSubmit)();
    closeModal();
  };

  return (
    <Dialog open={isOpened} onOpenChange={closeModal}>
      <DialogContent className="grid max-h-[calc(100dvh-1rem)] w-[calc(100%-1rem)] max-w-[640px] grid-rows-[auto_minmax(0,1fr)_auto] gap-0 overflow-hidden rounded-[14px] border-gray-200 bg-white p-0 font-sans shadow-xl sm:max-h-[calc(100dvh-3rem)] sm:rounded-[14px]">
        <header className="shrink-0 border-b border-gray-200 px-[18px] py-4 pr-14 sm:px-[26px] sm:py-5">
          <DialogHeader className="space-y-1 text-left">
            <DialogTitle className="text-lg font-semibold text-gray-900">Créer une nouvelle campagne</DialogTitle>
            <DialogDescription className="text-sm leading-5 text-gray-500">
              Configurez les paramètres de la nouvelle campagne. Tous les champs sont obligatoires.
            </DialogDescription>
          </DialogHeader>
        </header>

        <div className="min-h-0 overflow-y-auto overscroll-contain px-[18px] py-[17px] sm:px-[26px] sm:py-[19px]">
          <PreferencesForm
            form={form}
            onSubmit={onSubmit}
            currentYear={currentYear}
            campaigns={campaigns}
            isLoading={isLoading}
            isNewCampaign
          />
        </div>

        <footer className="shrink-0 border-t border-gray-200 bg-white px-[18px] py-3 sm:px-[26px]">
          <DialogFooter className="flex-row justify-end gap-3 sm:space-x-0">
            <Button variant="modal-secondary" size="modal" onClick={closeModal}>
              {Locales.base.button.discard}
            </Button>

            <Button variant="modal-primary" size="modal" disabled={isSubmitDisabled} onClick={handleAddCampaign}>
              {isLoading && <Spinner />}
              Créer la campagne
            </Button>
          </DialogFooter>
        </footer>
      </DialogContent>
    </Dialog>
  );
};

AddCampaignModal.propTypes = {
  isOpened: PropTypes.bool,
  closeModal: PropTypes.func,
  onSubmit: PropTypes.func,
  currentYear: PropTypes.number,
  isLoading: PropTypes.bool,
};

export default AddCampaignModal;
